import { render, staticRenderFns } from "./PointStatus.vue?vue&type=template&id=6d22a652&scoped=true&lang=pug&"
import script from "./PointStatus.vue?vue&type=script&lang=js&"
export * from "./PointStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22a652",
  null
  
)

export default component.exports